import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

export const Actions = styled.div`
  background-color: ${plume.COLORS.PRIMARY_GREY_000};
  display: flex;
  justify-content: end;
  margin: 0;
  padding: 16px 0;
  right: 0;
  z-index: 2;
  flex-direction: column;

  ${plume.LinkAsButton} {
    margin: 0 10px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    flex-direction: row;
    align-items: center;
    padding: 0;
    margin-top: 60px;
  }
`
